import React, { Component } from 'react'
import ToDoList from './ToDoList'
import { connect } from 'react-redux'
import { ADD_TO_DO, REMOVE_TO_DO, INCREMENT_COUNTER } from '../../redux/actions'

class ToDoApp extends Component {
  constructor(props) {
    super(props)
    this.state = { items: [], text: '' }
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleChange(e) {
    this.setState({ text: e.target.value })
  }

  handleSubmit(e) {
    e.preventDefault()
    if (this.state.text.length === 0) {
      return
    }
    const newItem = {
      text: this.state.text,
      id: Date.now(),
    }
    this.props.addNewToDo(newItem)
    this.props.incrementCounter()
    this.setState((state) => ({
      items: [...state.items, newItem],
      text: '',
    }))
  }

  handleRemove = (id) => (e) => {
    e.preventDefault()
    this.props.removeToDo(id)
  }

  render() {
    return (
      <div>
        <div>
          <h3>To Do Redux:</h3>
          <ToDoList handleRemove={this.handleRemove} items={this.props.todos} />
        </div>
        <div className="pad-box">
          <form onSubmit={this.handleSubmit}>
            <label>What needs to be done?</label>
            <input
              id="newToDo"
              onChange={this.handleChange}
              type="text"
              value={this.state.text}
            />
            <button>Add #{this.state.items.length + 1}</button>
            <p>{`No of clicks: ${this.props.counter}`}</p>
          </form>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  counter: state.counter.count, // add extra counter if combining reducers
  todos: state.todos.todos, // add extra todos if combining as sublevel
})

const mapDispatchToProps = (dispatch) => {
  return {
    addNewToDo: (todo) => dispatch({ type: ADD_TO_DO, payload: todo }),
    removeToDo: (id) => dispatch({ type: REMOVE_TO_DO, payload: id }),
    incrementCounter: () => dispatch({ type: INCREMENT_COUNTER }),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ToDoApp)
